import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { TImportMap, TNewImportMap } from '~/shared/import/map/types';

export class ImportMapModel extends ManagerResource {
  index(companyId: number, requestConfig?: TApiHttpClientRequestConfig): Promise<TImportMap[]> {
    return this.get<TImportMap[]>(`companies/${companyId}/import-map`, undefined, requestConfig);
  }

  create(
    companyId: number,
    payload: TNewImportMap,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TImportMap> {
    return this.post<TImportMap>(`companies/${companyId}/import-map`, payload, requestConfig);
  }

  update(
    id: number,
    payload: TNewImportMap,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TImportMap> {
    return this.post<TImportMap>(`import-map/${id}`, payload, requestConfig);
  }

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`import-map/${id}`, undefined, requestConfig);
  }
}
